/**
 * Main application entry point.
 */

'use strict';

var app    = require('mag-app');

// main application events
app.once('load', function () {
    require('spa-gettext').load({name: core.environment.language || 'en'}, function ( error ) {

        if ( error ) {
            console.log(error);
        }

        console.log('===========================================', '');
        console.log('PHOTO viewer', '');
        console.log('===========================================', '');
        app.pages = {
            main: require('./pages/main'),
            clear: require('./pages/clear')
        };

        // go to the main page when necessary
        app.route(app.pages.main);


    });
});
